import { ref } from "vue";
export default function systemVersion() {
  const appVersion = ref("Version 1.4.4");
  return { appVersion };
}
